
import { defineComponent, PropType } from 'vue'

import { FTLBidStatus } from '@/core/types/ftl_bids.types'

export default defineComponent({
    props: {
        statuses: {
            type: Array as PropType<FTLBidStatus[]>,
            default: () => []
        }
    }
})
